export const extractFirstLastName = (name) => {

    let names = _.split(_.trim(name), ' ');

    let firstName = '';
    let lastName = '';

    if (names.length == 1) {
        firstName = names[0];
        lastName = '';
    }
    else if (names.length > 1) {
        firstName = names[0];
        names.splice(0, 1);
        lastName = _.join(names, ' ');
    }

    firstName = _.trim(firstName);
    lastName = _.trim(lastName);

    return { firstName, lastName };
}